<script>
import UIUrlInput from '../components/ui/UIUrlInput';

export default {
  name: 'FileInputWithThumbnail',
  props: {
    id: { required: true },
    type: { type: String },
    media: Object,
    specs: String,
    ratio: Number,
    required: Boolean,
    ...UIUrlInput.options.props,
  },
  model: {
    prop: 'internalValue',
  },
  data: () => ({
    inputValue: '',
    localLoading: false,
  }),
  created () {
    if (this.media && this.media.src) {
      this.inputValue = this.media.src;
    }
  },
  methods: {
    async updateLink (value) {
      this.inputValue = value;

      const isImage = value.match(/\.(jpeg|jpg|png|gif)$/i);
      const isVideo = value.match(/\.(mp4|webm|ogg)$/i);

      const media = {
        id: this.id,
        name: this.id,
        title: value.split('/').pop(),
        src: value,
        type: isImage ? 'image' : isVideo ? 'video' : 'unknown',
      };

      this.$emit('input', media);
    },
    clearLink () {
      this.inputValue = '';
      this.$emit('clear', { id: this.id });
      this.$emit('input', { id: this.id, src: '', name: this.id });
    },
  },
  render (h) {
    return h(UIUrlInput, {
      props: {
        ...this.$props,
        file: this.media
          ? { name: this.media.name || '', thumbnail: this.media.thumbnail, url: this.inputValue }
          : null,
        ratio: this.ratio,
        loading: this.localLoading,
        type: this.type,
      },
      attrs: this.$attrs,
      on: {
        change: this.updateLink,
        clear: this.clearLink,
      },
    });
  },
};
</script>

<style scoped>
</style>
